import React from "react"
import PropTypes from "prop-types"
import ItemNameValueShape from "../../state/shapes/ItemNameValueShape"
import Widget from "../layout/widget/Widget"
import DoughnutChart from "../charts/generic/DoughnutChart"
import ChartComparison from "../ChartComparison"

function EngagementScoreDoughnut({
  exportEndpoint,
  appliedFilters,
  data,
  subtitleKey,
  sampleSize
}) {
  const hasComparisonData = false// !!(data[1] && data[1].value)
  const titleKey = "Widgets.EngagementScoreDoughnut.Title"
  return (
    <Widget
      columns={1}
      titleKey={titleKey}
      exportEndpoint={exportEndpoint}
      appliedFilters={appliedFilters}
      subtitleKey={subtitleKey}
      helpKey="Widgets.EngagementScore.Help"
      sampleSize={sampleSize}
    >
      <DoughnutChart
        data={data}
        suffix="%"
        chartThreshold={null}
        hasComparison={hasComparisonData}
        titleKey={titleKey}
        subtitleKey={subtitleKey}
      >
        {hasComparisonData && (
          <ChartComparison
            baseValue={data[0].value}
            comparisonOneValue={data[1] && data[1].value ? data[1].value : null}
            comparisonOneText="Common.LastSixMonths"
            comparisonTwoValue={data[2] && data[2].value ? data[2].value : null}
            comparisonTwoText="Common.LastTwelveMonths"
            increaseIsGood
            translateText
            usePercentage
          />
        )}
      </DoughnutChart>
    </Widget>
  )
}

EngagementScoreDoughnut.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.shape(ItemNameValueShape)).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default EngagementScoreDoughnut



// WEBPACK FOOTER //
// ./src/components/widgets/EngagementScoreDoughnut.jsx